import axios from "axios";
import { IExpiredRaSearchReqParams, IRaSearchListResponse, IRaSearchReqParams } from "../../models/models";

// PATHS
const RA_SEARCH_LIST = '/network/ra/search';
const RA_CUSTOMER_REPORTS = '/network/customer_report/ra/';
const VEHICLE_ACRISS_ALL = '/masterdatavehicle/acriss/all';

const raSearchList: any = async (req: IRaSearchReqParams | IExpiredRaSearchReqParams): Promise<IRaSearchListResponse> => {
    const response = await axios.post(RA_SEARCH_LIST, req);
    return response.data;
}

const fetchVehicleAcrissAll: any = async (param: string[]): Promise<IRaSearchListResponse> => {
    const params = param.map((elem: string) => `tenant=${elem}`).join('&');
    const response = await axios.get(VEHICLE_ACRISS_ALL + '?' + params);
    return response.data;
}

const fetchRaCustomerReports: any = async (raId: string,scenario: string) => {
    const response = await axios.get(RA_CUSTOMER_REPORTS + encodeURIComponent(raId)+'/'+encodeURIComponent(scenario));
    return response.data;
}

export {
    raSearchList,
    fetchVehicleAcrissAll,
    fetchRaCustomerReports,
}